module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/medium-self-5x15-75x600.svg";